import {
  useGlobalNotifier,
  useMessage,
  useSpreadsheetState,
} from "@vrf/fr-vrf-core-react";
import { FrVrfSpreadsheet } from "@vrf/fr-vrf-spreadsheet-react";
import {
  FrVrfAccordion,
  FrVrfButton,
  FrVrfButtonPanel,
  FrVrfFooter,
  FrVrfFormPanel,
  FrVrfHorizontalSeparator,
  FrVrfPanel,
  FrVrfSingleLineDisplayField,
  FrVrfSingleLinkDisplayField,
  FrVrfTextDisplayField,
} from "@vrf/fr-vrf-web-components-react";
import { stringify } from "../../util/querystring-util";
import React, { useEffect, useMemo } from "react";
import { createPath, useLocation, useNavigate } from "react-router-dom";
import {
  ComponentProjectDetailPageState,
  NecFlgCell,
  ProtocolListSpreadsheetState,
  ProtocolSpreadsheetRow,
  RelatedIdfSpreadsheetRow,
  RelatedIdfSpreadsheetState,
  Stakeholders,
  TaskInfo,
  TaskList,
  TaskListLv5SpreadsheetState,
  TaskListSpreadsheetState,
  TaskLv5SpreadsheetRow,
  TaskSpreadsheetRow,
  TaskStatusSpreadsheetRow,
  TaskStatusSpreadsheetState,
  usePageState,
} from ".";
import { useAppState } from "../../app";
import { ApplicationMessageScreen } from "../../messages/screen-message";
import {
  StupTaskList,
  StupTckts,
  UpdateStupTaskCtgries,
  UpdateStupTasks,
  useGetComponentProject,
  useUpdateComponentProject,
} from "../../services/component-project";
import { useGetGeneralCodes } from "../../services/data-list";
import { SeparateDateWithSlash } from "../../util/date-util";
import {
  CpntPjtType,
  DeploymentRequestScreenProcessingDivisionType,
  EnvTypeCd,
  InDefCommonFlagType,
  PjtType,
  RoleType,
} from "../../util/general-code/enums/general-codes";
import { Option } from "../../util/option";
import { INIT_ERROR_RESULT_DATA } from "../../util/spreadsheet-data-utils";
import {
  DesignInfoInputDialogContent,
  useDesignInfoInputDialogState,
} from "../dialog/design-info-input-dialog";
import {
  ProjectStakeholderListContent,
  ProjectStakeholderListInitialState,
  useProjectStakeholderListState,
} from "../dialog/project-stakeholder-list";
import { PartnerDetailMode } from "../partner-detail/PartnerDetailPageConstant";
import {
  EDI_NOTIFICATOR_TASK_TEMPLATE_FILE_URL,
  EVENT_CLICK_DSIGN_INFO_VIEW,
  EVENT_CLICK_STATUS,
  EVENT_CLICK_STATUS_NEW_TAB_ICON,
  EVENT_EDIT_PROTOCOL_NEC,
  EVENT_EDIT_TASK_NEC,
  EVENT_EDIT_TASK_TODO,
  PROTOCOL_TEMPLATE_FILE_URL,
  RELATED_IDF_PJT_TEMPLATE_FILE_URL,
  REQUEST_CD_TYPES,
  TASK_STATUS_TEMPLATE_FILE_URL,
  TASK_TEMPLATE_FILE_URL,
  requestCdTypes,
} from "./ComponentProjectDetailPageConstant";
import {
  MemoEditDialogContent,
  MemoType,
  useMemoEditDialogState,
} from "../dialog/memo-edit-dialog";
import { Cell } from "@vrf/fr-vrf-spreadsheet-core-templating";
import _ from "lodash";
export const ComponentProjectDetailPageContent = () => {
  const { showConfirmationDialog, showToast, resetUserError } =
    useGlobalNotifier();
  const { messageForScreen } = useMessage();
  const search = useLocation().search;
  const queryParameter = new URLSearchParams(search);
  const params = {
    cpntPjtId: queryParameter.get("cpntPjtId") ?? "",
  };
  const [_appState, setAppState] = useAppState();
  const [pageState, setPageState] = usePageState();
  const [getGeneralCodesResponse, sendGeneralCodesRequest] =
    useGetGeneralCodes();
  const [getComponentProjectResponse, sendGetComponentProjectRequest] =
    useGetComponentProject();
  const [getUpdateComponentProjectResponse, sendUpdateComponentProjectRequest] =
    useUpdateComponentProject();
  const [designInfoInputDialogState, setDesignInfoInputDialogState] =
    useDesignInfoInputDialogState();
  const { searchResult, dataList } =
    pageState as ComponentProjectDetailPageState;
  const [projectStakeholderListState, setProjectStakeholderListState] =
    useProjectStakeholderListState();
  const [memoEditDialogState, setMemoEditDialogState] =
    useMemoEditDialogState();
  const navigate = useNavigate();

  const [
    relatedIdfSpreadsheetState,
    setRelatedIdfSpreadsheetState,
    initRelatedIdfSpreadsheetState,
  ] = useSpreadsheetState<RelatedIdfSpreadsheetState>();

  const [
    protocolListSpreadsheetState,
    setProtocolListSpreadsheetState,
    initProtocolListSpreadsheetState,
  ] = useSpreadsheetState<ProtocolListSpreadsheetState>();

  const [
    taskListLv5SpreadsheetState,
    setTaskListLv5SpreadsheetState,
    initTaskListLv5SpreadsheetState,
  ] = useSpreadsheetState<TaskListLv5SpreadsheetState>();

  const [
    taskListSpreadsheetState,
    setTaskListSpreadsheetState,
    initTaskListSpreadsheetState,
  ] = useSpreadsheetState<TaskListSpreadsheetState>();

  const [
    taskStatusSpreadsheetState,
    setTaskStatusSpreadsheetState,
    initTaskStatusSpreadsheetState,
  ] = useSpreadsheetState<TaskStatusSpreadsheetState>();

  const onInitialDisplayed = () => {
    resetUserError();
    sendGeneralCodesRequest({ cdTypes: requestCdTypes });
    sendGetComponentProjectRequest({
      pjtId: params.cpntPjtId,
    });
    setAppState((prevState) => ({
      ...prevState,
      title: `Component Project Detail ( Project Name: ${
        pageState.projectInformation.pjtName || ""
      } )`,
    }));
  };

  const onGetGeneralCodesResponse = () => {
    let inDefCommonFlagType = [] as Option[];
    let roleType = [] as Option[];
    let GeneralCode = getGeneralCodesResponse?.gnrlCdTypeList ?? [];
    if (GeneralCode.length === 0) {
      return;
    }
    GeneralCode.map((e) => {
      switch (e.cdType) {
        case REQUEST_CD_TYPES.IN_DEF_COMMON_FLAG_TYPE:
          inDefCommonFlagType = e.cdList;
          break;
        case REQUEST_CD_TYPES.ROLE_TYPE:
          roleType = e.cdList;
      }
    });
    setPageState((prevState) => ({
      ...prevState,
      dataList: {
        ...prevState.dataList,
        inDefCommonFlagType,
        roleType,
      },
    }));
  };

  const getNecFlgCells = (tasksList: TaskLv5SpreadsheetRow[]) => {
    let set = new Set();
    let res: NecFlgCell = {};
    tasksList?.forEach((stupTask: TaskInfo) => {
      stupTask.task.stupTaskList?.forEach((stupTaskList: StupTaskList) => {
        if (
          !set.has(
            stupTask.task.stupTaskCtgryId + "-" + stupTaskList.stupTaskId,
          )
        ) {
          set.add(
            stupTask.task.stupTaskCtgryId + "-" + stupTaskList.stupTaskId,
          );
          res[stupTask.task.stupTaskCtgryId + "-" + stupTaskList.stupTaskId] = {
            isDirty: false,
            initialValue: stupTaskList.necFlg ?? "",
            currentValue: "",
          };
        }
      });
    });
    return res;
  };

  const getTaskListNecFlgCells = (tasksList: TaskSpreadsheetRow[]) => {
    let set = new Set();
    let res: NecFlgCell = {};
    tasksList?.forEach((stupTask: TaskInfo) => {
      stupTask.task.stupTaskList?.forEach((stupTaskList: StupTaskList) => {
        if (
          !set.has(
            stupTask.task.stupTaskCtgryId + "-" + stupTaskList.stupTaskId,
          )
        ) {
          set.add(
            stupTask.task.stupTaskCtgryId + "-" + stupTaskList.stupTaskId,
          );
          res[stupTask.task.stupTaskCtgryId + "-" + stupTaskList.stupTaskId] = {
            isDirty: false,
            initialValue: stupTaskList.necFlg ?? "",
            currentValue: "",
          };
        }
      });
    });
    return res;
  };

  const onGetComponentProjectResponse = () => {
    if (!getComponentProjectResponse) return;
    if (!Object.keys(getComponentProjectResponse).length) {
      return;
    }

    console.log("--------- getComponentProjectResponse ----------");
    console.log(getComponentProjectResponse);

    let stakeholders = {} as Stakeholders;
    const primMark = "*";
    const split = ", ";

    getComponentProjectResponse.stkhldrs?.forEach((e) => {
      switch (e.roleCd) {
        case RoleType.DIP_APPROVER:
          if (stakeholders.dipFr) {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.dipFr =
                primMark + e.userName + split + stakeholders.dipFr;
            } else {
              stakeholders.dipFr += split + e.userName;
            }
          } else {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.dipFr = primMark + e.userName;
            } else {
              stakeholders.dipFr = e.userName;
            }
          }
          break;
        case RoleType.PIC_OF_DIP_APP:
          if (stakeholders.dipApp) {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.dipApp =
                primMark + e.userName + split + stakeholders.dipApp;
            } else {
              stakeholders.dipApp += split + e.userName;
            }
          } else {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.dipApp = primMark + e.userName;
            } else {
              stakeholders.dipApp = e.userName;
            }
          }
          break;
        case RoleType.PIC_OF_DIP_INFRA:
          if (stakeholders.dipInfra) {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.dipInfra =
                primMark + e.userName + split + stakeholders.dipInfra;
            } else {
              stakeholders.dipInfra += split + e.userName;
            }
          } else {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.dipInfra = primMark + e.userName;
            } else {
              stakeholders.dipInfra = e.userName;
            }
          }
          break;
        case RoleType.PROJECT_APPROVER:
          if (stakeholders.bizApproval) {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.bizApproval =
                primMark + e.userName + split + stakeholders.bizApproval;
            } else {
              stakeholders.bizApproval += split + e.userName;
            }
          } else {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.bizApproval = primMark + e.userName;
            } else {
              stakeholders.bizApproval = e.userName;
            }
          }
          break;
        case RoleType.PIC_OF_COMPONENT_APP:
          if (stakeholders.bizInCharge) {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.bizInCharge =
                primMark + e.userName + split + stakeholders.bizInCharge;
            } else {
              stakeholders.bizInCharge += split + e.userName;
            }
          } else {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.bizInCharge = primMark + e.userName;
            } else {
              stakeholders.bizInCharge = e.userName;
            }
          }
          break;
        case RoleType.PIC_OF_COMPONENT_INFRA:
          if (stakeholders.bizInfra) {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.bizInfra =
                primMark + e.userName + split + stakeholders.bizInfra;
            } else {
              stakeholders.bizInfra += split + e.userName;
            }
          } else {
            if (InDefCommonFlagType.YES === e.primFlg) {
              stakeholders.bizInfra = primMark + e.userName;
            } else {
              stakeholders.bizInfra = e.userName;
            }
          }
          break;
      }
    });

    const primarySortingCompletionFlag =
      getComponentProjectResponse.stupTaskCtgries.filter(
        (e) => e.necFlg === null,
      ).length === 0;

    setPageState((prevState) => ({
      ...prevState,
      searchResult: getComponentProjectResponse,
      projectInformation: getComponentProjectResponse.cmpPjtInfo,
      stakeholders,
      componentAttributeStatus: getComponentProjectResponse.cpntAttrStatus,
      primarySortingCompletionFlag,
    }));

    console.log("---- 検索後 ＝＝＝＝＝＝＝＝");
    console.log(pageState.searchResult);
  };

  const relatedIdfSpreadsheetInitialData =
    useMemo<RelatedIdfSpreadsheetState>(() => {
      const newRelatedIdfList: RelatedIdfSpreadsheetRow[] =
        searchResult.relatedIfPjts?.map((e) => {
          const relatedIfPjts: RelatedIdfSpreadsheetRow = {
            ...INIT_ERROR_RESULT_DATA,
            relatedIfPjts: e,
          };
          return relatedIfPjts;
        });
      return {
        relatedIdfProjectList: newRelatedIdfList,
        dataList: dataList,
      };
    }, [searchResult.relatedIfPjts]);

  const protoclListSpreadsheetInitialData =
    useMemo<ProtocolListSpreadsheetState>(() => {
      const newProtocolList: ProtocolSpreadsheetRow[] =
        searchResult.stupTaskCtgries?.map((e) => {
          const setupTaskCategoryInfo: ProtocolSpreadsheetRow = {
            ...INIT_ERROR_RESULT_DATA,
            isEdited: false,
            stupTaskCtgries: e,
          };
          return setupTaskCategoryInfo;
        });
      return {
        protocolList: newProtocolList,
        dataList: dataList,
        reqTskSlctdFlg: pageState.projectInformation.reqTskSlctdFlg,
      };
    }, [searchResult.stupTaskCtgries]);

  const taskListLv5SpreadsheetInitialData =
    useMemo<TaskListLv5SpreadsheetState>(() => {
      let i = 0;
      const newTaskLv5List: TaskLv5SpreadsheetRow[] = searchResult.stupTasks
        .map((e) => {
          const taskInfo: TaskLv5SpreadsheetRow = {
            ...INIT_ERROR_RESULT_DATA,
            isEdited: false,
            idx: i++,
            task: e,
          };
          return taskInfo;
        })
        .filter((e) => {
          const targetStupTaskCtgry = searchResult.stupTaskCtgries.find(
            (stupTaskCtgry) =>
              stupTaskCtgry.stupTaskCtgryId === e.task.stupTaskCtgryId,
          );
          return (
            !!targetStupTaskCtgry &&
            targetStupTaskCtgry.necFlg === InDefCommonFlagType.YES
          );
        });
      return {
        taskList: newTaskLv5List,
        dataList: dataList,
        necFlgCell: getNecFlgCells(newTaskLv5List),
        reqTskSlctdFlg: pageState.projectInformation.reqTskSlctdFlg,
      };
    }, [searchResult.stupTasks]);

  const taskStatusSpreadsheetInitialData =
    useMemo<TaskStatusSpreadsheetState>(() => {
      const newTaskStatusList: TaskStatusSpreadsheetRow[] =
        searchResult.stupTckts?.map((e) => {
          const taskStatusInfo: TaskStatusSpreadsheetRow = {
            ...INIT_ERROR_RESULT_DATA,
            taskStatus: e,
          };
          return taskStatusInfo;
        });
      return {
        taskStatusList: newTaskStatusList,
        dataList: dataList,
      };
    }, [searchResult.stupTckts]);

  const taskListSpreadsheetInitialData =
    useMemo<TaskListSpreadsheetState>(() => {
      let i = 0;
      const newTaskList: TaskSpreadsheetRow[] = searchResult.stupTasks?.map(
        (e) => {
          const taskInfo: TaskSpreadsheetRow = {
            ...INIT_ERROR_RESULT_DATA,
            isEdited: false,
            idx: i++,
            task: e,
          };
          return taskInfo;
        },
      );
      return {
        taskList: newTaskList,
        dataList: dataList,
        necFlgCell: getTaskListNecFlgCells(newTaskList),
        reqTskSlctdFlg: pageState.projectInformation.reqTskSlctdFlg,
      };
    }, [searchResult.stupTasks]);

  const onGetUpdateComponentProjectResponse = () => {
    if (getUpdateComponentProjectResponse) {
      onInitialDisplayed();
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });
    }
  };

  const onListenCloseProjectStakeholderList = (): void => {
    if (projectStakeholderListState === undefined) return;
    if (
      projectStakeholderListState.isShow === false &&
      projectStakeholderListState.status.isSaved === true
    )
      onInitialDisplayed();
  };
  useEffect(onListenCloseProjectStakeholderList, [
    projectStakeholderListState.isShow,
  ]);

  const reloadInStakeholderList = (): void => {
    if (projectStakeholderListState.reqReload === false) return;
    sendGetComponentProjectRequest({
      pjtId: params.cpntPjtId,
    });
    setProjectStakeholderListState({
      ...projectStakeholderListState,
      reqReload: false,
    });
  };
  useEffect(reloadInStakeholderList, [projectStakeholderListState.reqReload]);

  const onListenGetProjectResponseInProjectStakeholderList = () => {
    if (projectStakeholderListState.isShow !== true) return;

    setProjectStakeholderListState({
      ...projectStakeholderListState,
      saved: pageState.searchResult.stkhldrs,
      edited: pageState.searchResult.stkhldrs,
      updateDateTime: pageState.searchResult.cmpPjtInfo.updateDateTime,
      status: ProjectStakeholderListInitialState.status,
    });
  };
  useEffect(onListenGetProjectResponseInProjectStakeholderList, [
    pageState.searchResult.stkhldrs,
  ]);

  const onCloseDesignInfoInputDialog = () => {
    if (designInfoInputDialogState.isShow) return;
    if (!taskListLv5SpreadsheetState || !protocolListSpreadsheetState) return;

    const targetIndex = designInfoInputDialogState.task.idx;

    const pageTaskList: TaskLv5SpreadsheetRow[] =
      taskListLv5SpreadsheetState.taskList.map((e) => {
        if (e.idx === targetIndex) {
          return {
            ...e,
            isEdited: true,
          };
        }
        return e;
      });

    const newTaskListLv5State: TaskListLv5SpreadsheetState = {
      ...taskListLv5SpreadsheetState,
      taskList: pageTaskList,
    };

    setTaskListLv5SpreadsheetState(newTaskListLv5State);

    const newProtocolList: ProtocolSpreadsheetRow[] =
      protocolListSpreadsheetState?.protocolList.map((e) => {
        if (
          e.stupTaskCtgries.stupTaskCtgryId ===
          designInfoInputDialogState.task.stupTasks.stupTaskCtgryId
        ) {
          return {
            ...e,
            isEdited: true,
          };
        }
        return e;
      });

    const newProtocolListState: ProtocolListSpreadsheetState = {
      ...protocolListSpreadsheetState,
      protocolList: newProtocolList,
    };
    setProtocolListSpreadsheetState(newProtocolListState);
  };

  useEffect(onInitialDisplayed, []);
  useEffect(onGetGeneralCodesResponse, [getGeneralCodesResponse]);
  useEffect(onGetComponentProjectResponse, [getComponentProjectResponse]);
  useEffect(onGetUpdateComponentProjectResponse, [
    getUpdateComponentProjectResponse,
  ]);
  useEffect(onCloseDesignInfoInputDialog, [designInfoInputDialogState.isShow]);
  useEffect(() => {
    setAppState((prevState) => ({
      ...prevState,
      title: `Component Project Detail ( Project Name: ${
        pageState.projectInformation.pjtName || ""
      } )`,
    }));
  }, [pageState.projectInformation.pjtName]);

  const onClickLink = (name: string) => (event: CustomEvent) => {
    if (event.detail.rowIndex === 0) return;
    if (name === "editStakeholders") {
      if (!checkEdited()) {
        setProjectStakeholderListState({
          ...projectStakeholderListState,
          saved: pageState.searchResult.stkhldrs,
          edited: pageState.searchResult.stkhldrs,
          pjtId: params.cpntPjtId,
          pjtTypeCd: PjtType.COMPONENT,
          updateDateTime: pageState.searchResult.cmpPjtInfo.updateDateTime,
          isShow: true,
        });
        return;
      }
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
        onOkButtonClicked: () => {
          setProjectStakeholderListState({
            ...projectStakeholderListState,
            saved: pageState.searchResult.stkhldrs,
            edited: pageState.searchResult.stkhldrs,
            pjtId: params.cpntPjtId,
            pjtTypeCd: PjtType.COMPONENT,
            updateDateTime: pageState.searchResult.cmpPjtInfo.updateDateTime,
            isShow: true,
          });
        },
      });
    }
    if (name === "objective") {
      const navigationParameters = {
        pjtId: event.detail.value.relatedIfPjts.pjtId,
      };
      if (checkEdited()) {
        createDiscardDialog(() =>
          transition(`/project-detail?${stringify(navigationParameters)}`),
        );
      } else {
        transition(`/project-detail?${stringify(navigationParameters)}`);
      }
    }
    if (name === "designStatus") {
      const navigationParameters = {
        dipByRgn: searchResult.cmpPjtInfo.dipByRgn,
        rootCpntId: searchResult.cmpPjtInfo.rootCpntId,
        cpntId: searchResult.cmpPjtInfo.cpntId,
      };
      if (checkEdited()) {
        createDiscardDialog(() =>
          transition(`/component-detail?${stringify(navigationParameters)}`),
        );
      } else {
        transition(`/component-detail?${stringify(navigationParameters)}`);
      }
    }
    if (name === "stgDeployStatus") {
      let navigationParameters = {};
      if (CpntPjtType.EDH === searchResult.cmpPjtInfo.cpntPjtTypeCd) {
        navigationParameters = {
          screenMode: DeploymentRequestScreenProcessingDivisionType.NORMAL_MODE,
          dipByRgn: searchResult.cmpPjtInfo.dipByRgn,
          cpntId: searchResult.cmpPjtInfo.cpntId,
          inOutTypeCd: searchResult.cmpPjtInfo.inOutTypeCd,
          edhPrtclTypeCd: searchResult.cmpPjtInfo.prtcolTypeCd,
          environment: EnvTypeCd.STG,
        };
      } else {
        navigationParameters = {
          screenMode: DeploymentRequestScreenProcessingDivisionType.NORMAL_MODE,
          dipByRgn: searchResult.cmpPjtInfo.dipByRgn,
          cpntId: searchResult.cmpPjtInfo.cpntId,
          inOutTypeCd: searchResult.cmpPjtInfo.inOutTypeCd,
          environment: EnvTypeCd.STG,
        };
      }
      if (checkEdited()) {
        createDiscardDialog(() =>
          transition(
            `/component-deployment-request-list?${stringify(
              navigationParameters,
            )}`,
          ),
        );
      } else {
        transition(
          `/component-deployment-request-list?${stringify(
            navigationParameters,
          )}`,
        );
      }
    }
    if (name === "prdDeployStatus") {
      let navigationParameters = {};
      if (CpntPjtType.EDH === searchResult.cmpPjtInfo.cpntPjtTypeCd) {
        navigationParameters = {
          screenMode: DeploymentRequestScreenProcessingDivisionType.NORMAL_MODE,
          dipByRgn: searchResult.cmpPjtInfo.dipByRgn,
          cpntId: searchResult.cmpPjtInfo.cpntId,
          inOutTypeCd: searchResult.cmpPjtInfo.inOutTypeCd,
          edhPrtclTypeCd: searchResult.cmpPjtInfo.prtcolTypeCd,
          environment: EnvTypeCd.PRD,
        };
      } else {
        navigationParameters = {
          screenMode: DeploymentRequestScreenProcessingDivisionType.NORMAL_MODE,
          dipByRgn: searchResult.cmpPjtInfo.dipByRgn,
          cpntId: searchResult.cmpPjtInfo.cpntId,
          inOutTypeCd: searchResult.cmpPjtInfo.inOutTypeCd,
          environment: EnvTypeCd.PRD,
        };
      }
      if (checkEdited()) {
        createDiscardDialog(() =>
          transition(
            `/component-deployment-request-list?${stringify(
              navigationParameters,
            )}`,
          ),
        );
      } else {
        transition(
          `/component-deployment-request-list?${stringify(
            navigationParameters,
          )}`,
        );
      }
    }
  };

  const transition = (path: string) => {
    const href = createPath({
      pathname: path,
    });
    navigate(href);
  };

  const onCellClickedStupTckts = (event: CustomEvent) => {
    if (event.detail.rowIndex === 0) return;
    const eventName: string = event.detail.name;
    const selectedRow: StupTckts = event.detail.value.taskStatus;
    if (!selectedRow.tcktId) return;
    if (eventName === EVENT_CLICK_STATUS) {
      const navigationParameters = {
        tcktId: selectedRow.tcktId,
      };
      if (checkEdited()) {
        createDiscardDialog(() =>
          transition(`/ticket-detail?${stringify(navigationParameters)}`),
        );
      } else {
        transition(`/ticket-detail?${stringify(navigationParameters)}`);
      }
    }
    if (eventName === EVENT_CLICK_STATUS_NEW_TAB_ICON) {
      const navigationParameters = {
        tcktId: selectedRow.tcktId,
      };
      const href = createPath({
        pathname: `/ticket-detail?${stringify(navigationParameters)}`,
      });
      window.open(window.location.pathname + "#" + href);
    }
  };

  const onCellClicked = (event: CustomEvent) => {
    if (event.detail.rowIndex === 0) return;
    const eventName: string = event.detail.name;
    if (eventName === EVENT_CLICK_DSIGN_INFO_VIEW) {
      const value = event.detail.value;
      const taskList: TaskList = {
        idx: value.idx,
        stupTasks: value.task,
      };
      setDesignInfoInputDialogState((prevState) => ({
        ...prevState,
        designInfo: value.task.dsgnInfo,
        task: taskList,
        isShow: true,
        reqTskSlctdFlg: pageState.projectInformation.reqTskSlctdFlg,
      }));
    }
  };

  const onCellEdited = (event: CustomEvent) => {
    const rowIndex = event.detail.cell.data.index as number;
    const value = event.detail.cell.value ?? "";
    const eventName: string = event.detail.name;
    const isChanged: boolean = event.detail.cell.row.isChanged;
    const listIndex = event.detail.value.idx as number;

    if (eventName === EVENT_EDIT_PROTOCOL_NEC) {
      if (!protocolListSpreadsheetState) return;
      const copyProtocolList: ProtocolListSpreadsheetState["protocolList"] =
        JSON.parse(JSON.stringify(protocolListSpreadsheetState?.protocolList));
      copyProtocolList[rowIndex]["stupTaskCtgries"]["necFlg"] = value;
      copyProtocolList[rowIndex].isEdited = isChanged;

      const newState: ProtocolListSpreadsheetState = {
        ...protocolListSpreadsheetState,
        protocolList: copyProtocolList,
      };
      setProtocolListSpreadsheetState(newState);
    } else if (eventName === EVENT_EDIT_TASK_NEC) {
      if (!taskListLv5SpreadsheetState) return;
      const copyTaskLv5List: TaskListLv5SpreadsheetState["taskList"] =
        JSON.parse(JSON.stringify(taskListLv5SpreadsheetState?.taskList));

      const targetTaskLv5 = copyTaskLv5List.find((e) => e.idx === listIndex);
      if (!targetTaskLv5) return;

      targetTaskLv5["task"]["stupTaskList"]![rowIndex]["necFlg"] = value;
      targetTaskLv5.isEdited = isChanged;

      const copyNecFlgCells =
        taskListLv5SpreadsheetState.necFlgCell as NecFlgCell;
      let key =
        targetTaskLv5["task"]["stupTaskCtgryId"] +
        "-" +
        targetTaskLv5["task"]["stupTaskList"]![rowIndex]["stupTaskId"];
      copyNecFlgCells[key].isDirty = event.detail.cell.isDirty;

      const newState: TaskListLv5SpreadsheetState = {
        ...taskListLv5SpreadsheetState,
        taskList: copyTaskLv5List,
        necFlgCell: copyNecFlgCells,
      };
      setTaskListLv5SpreadsheetState(newState);
    } else if (eventName === EVENT_EDIT_TASK_TODO) {
      if (!taskListSpreadsheetState) return;
      const copyTaskList: TaskListSpreadsheetState["taskList"] = JSON.parse(
        JSON.stringify(taskListSpreadsheetState?.taskList),
      );
      copyTaskList[listIndex]["task"]["stupTaskList"]![rowIndex]["necFlg"] =
        value;
      copyTaskList[listIndex].isEdited = isChanged;

      const copyTaskNecFlgCells =
        taskListSpreadsheetState.necFlgCell as NecFlgCell;
      const key =
        copyTaskList![listIndex]["task"]["stupTaskCtgryId"] +
        "-" +
        copyTaskList![listIndex]["task"]["stupTaskList"]![rowIndex][
          "stupTaskId"
        ];
      copyTaskNecFlgCells[key].isDirty = event.detail.cell.isDirty;

      const newState: TaskListSpreadsheetState = {
        ...taskListSpreadsheetState,
        taskList: copyTaskList,
        necFlgCell: copyTaskNecFlgCells,
      };
      setTaskListSpreadsheetState(newState);
    }
  };

  const onProtocolCellBulkEdited = (event: CustomEvent) => {
    if (!protocolListSpreadsheetState) return;
    const newProtocolListSpreadsheet = _.cloneDeep(
      protocolListSpreadsheetState?.protocolList,
    ) as ProtocolSpreadsheetRow[];

    event.detail.affectedCells.cells.forEach((item: Cell) => {
      const value: string = item.value;
      const rowIdx: number = item.data.index;
      const isChanged: boolean = item.row.isChanged;
      newProtocolListSpreadsheet[rowIdx].stupTaskCtgries.necFlg = value;
      newProtocolListSpreadsheet[rowIdx].isEdited = isChanged;
    });

    setProtocolListSpreadsheetState({
      ...protocolListSpreadsheetState,
      protocolList: newProtocolListSpreadsheet,
    });
  };

  const onTaskCellBulkEdited = (
    event: CustomEvent,
    taskListSheetState?: TaskListSpreadsheetState,
  ) => {
    if (!taskListSheetState) return;
    const newTaskList = _.cloneDeep(
      taskListSheetState?.taskList,
    ) as TaskSpreadsheetRow[];

    const rowNums = newTaskList.map(
      (task, index) => task.task.stupTaskList?.length || 0,
    );

    event.detail.affectedCells.cells.forEach((item: Cell) => {
      const value: string = item.value;
      const rowIdx: number = item.data.index;
      const isChanged: boolean = item.row.isChanged;
      let parentIdx = 0;
      let rowSums = 0;
      // there is used union cells in spreadsheet, so need to calculate parent index
      while (rowIdx >= rowSums) {
        rowSums += rowNums[parentIdx];
        if (rowIdx < rowSums) {
          break;
        }
        parentIdx++;
      }
      const task =
        newTaskList[parentIdx].task.stupTaskList![
          rowIdx - (rowSums - rowNums[parentIdx])
        ];
      task.necFlg = value;
      newTaskList[parentIdx].isEdited = isChanged;
    });
    setTaskListSpreadsheetState({
      ...taskListSheetState,
      taskList: newTaskList,
    });
  };

  const onClickCompleteInputNecessity =
    (completeTaskSelection: boolean) => () => {
      protocolListSpreadsheetState?.protocolList?.forEach((task) => {
        if (!task.stupTaskCtgries.necFlg) {
          showToast({
            design: "alert",
            message: messageForScreen(ApplicationMessageScreen.APP_SCN_00053),
          });
        }
      });
      taskListLv5SpreadsheetState?.taskList?.forEach((taskLv5Info) => {
        taskLv5Info.task.stupTaskList?.forEach((subTask) => {
          if (!subTask.necFlg) {
            showToast({
              design: "alert",
              message: messageForScreen(ApplicationMessageScreen.APP_SCN_00053),
            });
          }
        });
      });
      taskListSpreadsheetState?.taskList?.forEach((task) => {
        task.task.stupTaskList?.forEach((subTask) => {
          if (!subTask.necFlg) {
            showToast({
              design: "alert",
              message: messageForScreen(ApplicationMessageScreen.APP_SCN_00053),
            });
          }
        });
      });
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
        onOkButtonClicked: () => {
          resetUserError();
          const stupTaskCtgries = [] as UpdateStupTaskCtgries[];
          const stupTaskMap = new Map<string, string>();
          const stupTaskList = [] as UpdateStupTasks[];
          if (pageState.projectInformation.cpntPjtTypeCd === CpntPjtType.EDH) {
            searchResult.stupTasks.forEach((e) => {
              stupTaskMap.set(e.stupTaskCtgryId!, e.dsgnInfo!);
            });
            taskListLv5SpreadsheetState?.taskList?.forEach((ctgry) => {
              ctgry.task.stupTaskList?.forEach((task) => {
                const stupTask = {} as UpdateStupTasks;
                stupTask.stupTaskCtgryId = ctgry.task.stupTaskCtgryId ?? "";
                stupTask.stupTaskId = task.stupTaskId ?? "";
                stupTask.necFlg = task.necFlg ?? "";
                if (
                  taskListLv5SpreadsheetState.necFlgCell[
                    ctgry.task.stupTaskCtgryId + "-" + task.stupTaskId
                  ]?.isDirty
                ) {
                  stupTaskList.push(stupTask);
                }
              });
            });
            protocolListSpreadsheetState!
              .protocolList!.filter((e) => e.isEdited)
              .forEach((e) => {
                const stupTaskCtgry = {} as UpdateStupTaskCtgries;
                stupTaskCtgry.stupTaskCtgryId =
                  e.stupTaskCtgries.stupTaskCtgryId ?? "";
                stupTaskCtgry.necFlg = e.stupTaskCtgries.necFlg ?? "";
                stupTaskCtgry.dsgnInfo =
                  stupTaskMap.get(e.stupTaskCtgries.stupTaskCtgryId!) ?? "";
                stupTaskCtgries.push(stupTaskCtgry);
              });
          } else {
            if (!taskListSpreadsheetState) return;
            taskListSpreadsheetState
              .taskList!.filter((e) => e.isEdited)
              .forEach((ctgry) => {
                const stupTaskCtgry = {} as UpdateStupTaskCtgries;

                ctgry.task.stupTaskList?.forEach((task) => {
                  const stupTask = {} as UpdateStupTasks;
                  stupTask.stupTaskCtgryId = ctgry.task.stupTaskCtgryId;
                  stupTask.stupTaskId = task.stupTaskId;
                  stupTask.necFlg = task.necFlg;
                  if (
                    taskListSpreadsheetState.necFlgCell[
                      ctgry.task.stupTaskCtgryId + "-" + task.stupTaskId
                    ]?.isDirty
                  ) {
                    stupTaskList.push(stupTask);
                  }
                });

                const allStupTaskNecFlgIsNo = ctgry.task.stupTaskList.every(
                  (task) => task.necFlg === InDefCommonFlagType.NO,
                );

                stupTaskCtgry.stupTaskCtgryId = ctgry.task.stupTaskCtgryId;
                stupTaskCtgry.necFlg = allStupTaskNecFlgIsNo
                  ? InDefCommonFlagType.NO
                  : InDefCommonFlagType.YES;
                stupTaskCtgry.dsgnInfo = ctgry.task.dsgnInfo;

                stupTaskCtgries.push(stupTaskCtgry);
              });
          }
          sendUpdateComponentProjectRequest({
            pjtId: params.cpntPjtId,
            updateDateTime: pageState.projectInformation.updateDateTime,
            stupTaskCtgries: stupTaskCtgries,
            stupTasks: stupTaskList,
            taskSelectionCompleteFlg: completeTaskSelection
              ? InDefCommonFlagType.YES
              : InDefCommonFlagType.NO,
          });
        },
      });
    };

  const createDiscardDialog = (onOkButtonClicked: () => void) => {
    showConfirmationDialog({
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
      type: "warning",
      onOkButtonClicked,
    });
  };

  const checkEdited = () => {
    let isProtocolEdited: boolean = protocolListSpreadsheetState?.protocolList
      ? protocolListSpreadsheetState?.protocolList?.flatMap((e) => {
          if (e.isEdited) {
            return [true];
          }
          return [];
        }).length > 0
      : false;
    let isTaskLv5Edited: boolean = taskListLv5SpreadsheetState?.taskList
      ? taskListLv5SpreadsheetState?.taskList?.flatMap((e) => {
          if (e.isEdited) {
            return [true];
          }
          return [];
        }).length > 0
      : false;
    let isTaskEdited: boolean = taskListSpreadsheetState?.taskList
      ? taskListSpreadsheetState?.taskList?.flatMap((e) => {
          if (e.isEdited) {
            return [true];
          }
          return [];
        }).length > 0
      : false;
    return isProtocolEdited || isTaskLv5Edited || isTaskEdited;
  };

  const onClickPartnerLink = () => {
    const navigationParameters = {
      mode: PartnerDetailMode.MODIFY,
      partnerId: pageState.projectInformation.ptnrId,
      godFlg: InDefCommonFlagType.NO,
    };
    if (checkEdited()) {
      createDiscardDialog(() =>
        transition(`/partner-detail?${stringify(navigationParameters)}`),
      );
    } else {
      transition(`/partner-detail?${stringify(navigationParameters)}`);
    }
  };

  /** Memo Edit Dialog */
  const showMemoEditDialog = () => {
    console.log("---- showMemoEditDialog Edit Start ------");
    setMemoEditDialogState((prevState) => ({
      ...prevState,
      isShow: true,
      pjtId: params.cpntPjtId,
      mmTxt: pageState.searchResult.mmTxt,
      updateDateTime: pageState.searchResult.mmTxtUpdateDateTime,
      targetIndex: "",
      memoType: MemoType.PROJECT,
    }));
    console.log("---- showMemoEditDialog Edit End ------");
  };

  const onListenCloseMemoEditDialog = (): void => {
    if (memoEditDialogState === undefined) return;
    if (memoEditDialogState.isShow === false) {
      const editedMemo = memoEditDialogState.mmTxt;
      const editedMemoUpdateDateTime = memoEditDialogState.updateDateTime;
      setPageState((prevState) => ({
        ...prevState,
        searchResult: {
          ...prevState.searchResult,
          mmTxt: editedMemo,
          mmTxtUpdateDateTime: editedMemoUpdateDateTime,
        },
      }));

      console.log(
        `== close parent memo dialog. parent state[${pageState.searchResult}]`,
      );
    }
  };
  useEffect(onListenCloseMemoEditDialog, [memoEditDialogState.isShow]);

  return (
    <>
      {memoEditDialogState.isShow && <MemoEditDialogContent />}
      {designInfoInputDialogState.isShow && <DesignInfoInputDialogContent />}
      {projectStakeholderListState.isShow ? (
        <ProjectStakeholderListContent />
      ) : (
        <>
          <FrVrfFormPanel
            style={{
              "--vrf-form-panel-vertical-align": "top",
            }}
            columns={2}
          >
            <div>
              <FrVrfAccordion summary="Project Information">
                <FrVrfPanel>
                  <FrVrfFormPanel columns={2}>
                    <FrVrfFormPanel>
                      <FrVrfSingleLineDisplayField
                        label="DIP by Region"
                        firstValue={pageState.projectInformation.dipByRgn}
                      />
                      <FrVrfSingleLineDisplayField
                        label="Root Component ID"
                        firstValue={pageState.projectInformation.rootCpntId}
                      />
                      <FrVrfSingleLineDisplayField
                        label="Component ID"
                        firstValue={pageState.projectInformation.cpntId}
                      />
                      <FrVrfSingleLineDisplayField
                        label="In/Out"
                        firstValue={pageState.projectInformation.inOutTypeName}
                      />
                      <FrVrfSingleLineDisplayField
                        label="Protocol"
                        firstValue={pageState.projectInformation.prtcolTypeName}
                      />
                      <FrVrfSingleLinkDisplayField
                        labelContent="Partner"
                        content={pageState.projectInformation.ptnrName}
                        onClick={onClickPartnerLink}
                        visible={
                          CpntPjtType.EDI ===
                          pageState.projectInformation.cpntPjtTypeCd
                        }
                      />
                    </FrVrfFormPanel>
                    <FrVrfFormPanel>
                      <FrVrfSingleLineDisplayField
                        label="Project Type"
                        firstValue={
                          pageState.projectInformation.cpntPjtTypeName
                        }
                      />
                      <FrVrfSingleLineDisplayField
                        label="Project Status"
                        firstValue={
                          pageState.projectInformation.pjtStsDsplyName
                        }
                      />
                      <FrVrfSingleLineDisplayField
                        label="STG Only"
                        firstValue={
                          pageState.dataList.inDefCommonFlagType.find(
                            (e) =>
                              e.value ===
                              pageState.projectInformation.stgOnlyFlg,
                          )?.label || ""
                        }
                      />
                      <FrVrfSingleLineDisplayField
                        label="STG Deployment Scheduled Date"
                        firstValue={SeparateDateWithSlash(
                          pageState.projectInformation.stgSchedDplymntDate,
                        )}
                      />
                      <FrVrfSingleLineDisplayField
                        label="PRD Deployment Scheduled Date"
                        firstValue={SeparateDateWithSlash(
                          pageState.projectInformation.prdSchedDplymntDate,
                        )}
                      />
                    </FrVrfFormPanel>
                  </FrVrfFormPanel>
                </FrVrfPanel>
              </FrVrfAccordion>
            </div>
            <div>
              <FrVrfAccordion summary="Stakeholders">
                <FrVrfPanel>
                  <FrVrfSingleLineDisplayField
                    label="DIP FR"
                    firstValue={pageState.stakeholders.dipFr}
                  />
                  <FrVrfHorizontalSeparator />
                  <FrVrfSingleLineDisplayField
                    label="DIP APP"
                    firstValue={pageState.stakeholders.dipApp}
                  />
                  <FrVrfHorizontalSeparator />
                  <FrVrfSingleLineDisplayField
                    label="DIP Infra"
                    firstValue={pageState.stakeholders.dipInfra}
                  />
                  <FrVrfHorizontalSeparator />
                  <FrVrfSingleLineDisplayField
                    label="Biz Approval"
                    firstValue={pageState.stakeholders.bizApproval}
                  />
                  <FrVrfHorizontalSeparator />
                  <FrVrfSingleLineDisplayField
                    label="Biz In Charge"
                    firstValue={pageState.stakeholders.bizInCharge}
                  />
                  <FrVrfHorizontalSeparator />
                  <FrVrfSingleLineDisplayField
                    label="Biz Infra"
                    firstValue={pageState.stakeholders.bizInfra}
                  />
                  <FrVrfButtonPanel>
                    <FrVrfButton
                      content="Edit"
                      size="small"
                      theme="secondary"
                      onClicked={onClickLink("editStakeholders")}
                      authActId="component_project_detail.button.edit"
                    />
                  </FrVrfButtonPanel>
                </FrVrfPanel>
              </FrVrfAccordion>
            </div>

            <div>
              <FrVrfAccordion summary="Related IF Project List">
                <FrVrfPanel>
                  <FrVrfSpreadsheet
                    data={relatedIdfSpreadsheetInitialData}
                    onInitialized={initRelatedIdfSpreadsheetState}
                    templateUrl={RELATED_IDF_PJT_TEMPLATE_FILE_URL}
                    maxHeight={80}
                    onCellClicked={onClickLink("objective")}
                  />
                </FrVrfPanel>
              </FrVrfAccordion>
            </div>

            <div>
              {pageState.projectInformation.cpntPjtTypeCd === CpntPjtType.EDH &&
                (!!pageState.componentAttributeStatus.dsgnTcktId ||
                  !!pageState.componentAttributeStatus.stgDplymntTcktId ||
                  !!pageState.componentAttributeStatus.prdDplymntTcktId) && (
                  <FrVrfAccordion summary="Component Attribute Status">
                    <FrVrfPanel columns={2}>
                      <FrVrfSingleLinkDisplayField
                        labelContent="Design Status"
                        content={
                          pageState.componentAttributeStatus.dsgnStsDsplyName
                        }
                        style={{
                          "--vrf-single-link-display-field-label-width":
                            "200px",
                        }}
                        onClicked={onClickLink("designStatus")}
                      />
                      <FrVrfSingleLinkDisplayField
                        labelContent="STG Deployment Request Status"
                        content={
                          pageState.componentAttributeStatus
                            .stgDplymntStsDsplyName
                        }
                        style={{
                          "--vrf-single-link-display-field-label-width":
                            "200px",
                        }}
                        onClicked={onClickLink("stgDeployStatus")}
                      />
                      <div></div>
                      <FrVrfSingleLinkDisplayField
                        labelContent="PRD Deployment Request Status"
                        content={
                          pageState.componentAttributeStatus
                            .prdDplymntStsDsplyName
                        }
                        style={{
                          "--vrf-single-link-display-field-label-width":
                            "200px",
                        }}
                        onClicked={onClickLink("prdDeployStatus")}
                      />
                    </FrVrfPanel>
                  </FrVrfAccordion>
                )}
            </div>
          </FrVrfFormPanel>
          <FrVrfFormPanel>
            <FrVrfAccordion summary="Infrastructure Construction">
              <FrVrfPanel style={{ height: "510px" }}>
                {pageState.projectInformation.cpntPjtTypeCd ===
                  CpntPjtType.EDH && (
                  <div>
                    <FrVrfTextDisplayField text="Protocol(LV4)" />
                    <FrVrfSpreadsheet
                      data={protoclListSpreadsheetInitialData}
                      onInitialized={initProtocolListSpreadsheetState}
                      onCellEdited={onCellEdited}
                      onCellBulkEdited={onProtocolCellBulkEdited}
                      templateUrl={PROTOCOL_TEMPLATE_FILE_URL}
                      maxHeight={100}
                    />
                  </div>
                )}
                {(pageState.projectInformation.cpntPjtTypeCd ===
                  CpntPjtType.EDI ||
                  pageState.projectInformation.cpntPjtTypeCd ===
                    CpntPjtType.NOTIFICATOR) && (
                  <div>
                    <FrVrfTextDisplayField text="Task List" />
                    <FrVrfSpreadsheet
                      data={taskListSpreadsheetInitialData}
                      onInitialized={initTaskListSpreadsheetState}
                      onCellEdited={onCellEdited}
                      onCellBulkEdited={(e) =>
                        onTaskCellBulkEdited(e, taskListSpreadsheetState)
                      }
                      templateUrl={EDI_NOTIFICATOR_TASK_TEMPLATE_FILE_URL}
                      maxHeight={200}
                    />
                  </div>
                )}
                {pageState.projectInformation.cpntPjtTypeCd ===
                  CpntPjtType.EDH &&
                  pageState.primarySortingCompletionFlag && (
                    <div>
                      <FrVrfTextDisplayField text="Task List(LV5)" />
                      <FrVrfSpreadsheet
                        data={taskListLv5SpreadsheetInitialData}
                        onInitialized={initTaskListLv5SpreadsheetState}
                        onCellClicked={onCellClicked}
                        onCellEdited={onCellEdited}
                        onCellBulkEdited={(e) =>
                          onTaskCellBulkEdited(e, taskListLv5SpreadsheetState)
                        }
                        templateUrl={TASK_TEMPLATE_FILE_URL}
                        maxHeight={150}
                      />
                    </div>
                  )}
                {true && (
                  <div>
                    <FrVrfTextDisplayField text="Task Status" />
                    <FrVrfSpreadsheet
                      data={taskStatusSpreadsheetInitialData}
                      onInitialized={initTaskStatusSpreadsheetState}
                      onCellClicked={onCellClickedStupTckts}
                      templateUrl={TASK_STATUS_TEMPLATE_FILE_URL}
                    />
                  </div>
                )}
                <div>
                  <FrVrfButtonPanel>
                    {pageState.projectInformation.cpntPjtTypeCd ===
                      CpntPjtType.EDH && (
                      <FrVrfButton
                        content="Save Input Necessity"
                        theme="primary"
                        size="large"
                        disabled={
                          protocolListSpreadsheetState?.protocolList.every(
                            (e) => !e.isEdited,
                          ) &&
                          (taskListLv5SpreadsheetState
                            ? taskListLv5SpreadsheetState.taskList.every(
                                (e) => !e.isEdited,
                              )
                            : true)
                        }
                        onClicked={onClickCompleteInputNecessity(false)}
                        authActId="component_project_detail.button.save_input_necessity"
                        visible={
                          pageState.projectInformation.reqTskSlctdFlg ===
                          InDefCommonFlagType.NO
                        }
                      />
                    )}
                    {(pageState.primarySortingCompletionFlag ||
                      pageState.projectInformation.cpntPjtTypeCd ===
                        CpntPjtType.EDI ||
                      pageState.projectInformation.cpntPjtTypeCd ===
                        CpntPjtType.NOTIFICATOR) && (
                      <FrVrfButton
                        content="Complete Task Selection"
                        theme="primary"
                        size="large"
                        disabled={
                          taskListLv5SpreadsheetState?.taskList.some((e) =>
                            e.task.stupTaskList.some(
                              (task) => task.necFlg === null,
                            ),
                          ) ||
                          taskListSpreadsheetState?.taskList.some((e) =>
                            e.task.stupTaskList.some(
                              (task) => task.necFlg === null,
                            ),
                          )
                        }
                        onClicked={onClickCompleteInputNecessity(true)}
                        authActId="component_project_detail.button.complete_task_selection"
                        visible={
                          pageState.projectInformation.reqTskSlctdFlg ===
                          InDefCommonFlagType.NO
                        }
                      />
                    )}
                  </FrVrfButtonPanel>
                </div>
              </FrVrfPanel>
            </FrVrfAccordion>
            {/* Project Memo Area */}
            <FrVrfAccordion summary="Memo">
              <FrVrfPanel
                description=""
                columns={1}
                style={{ minHeight: "100px" }}
              >
                <FrVrfTextDisplayField
                  className="whiteSpace"
                  text={pageState.searchResult.mmTxt}
                />
                <FrVrfButtonPanel align="right">
                  <FrVrfButton
                    style={{ marginLeft: "30px" }}
                    content="Edit"
                    theme="secondary"
                    size="small"
                    onClicked={showMemoEditDialog}
                  />
                </FrVrfButtonPanel>
              </FrVrfPanel>
            </FrVrfAccordion>
          </FrVrfFormPanel>
        </>
      )}
    </>
  );
};
